import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { SpaceService } from './../../../services/space.service';
import { MemberService } from './../../../rest/api/member.service';
import { AuthService } from './../../../services/auth.service';

import _ from 'lodash';

@Component({
  selector: 'app-showcase',
  templateUrl: './showcase.component.html',
  styleUrls: ['./showcase.component.scss']
})
export class ShowcaseComponent implements OnInit {
  spaceData: any;
  mediaData: any;
  highLightReelData: any;
  hotspotListData: any;
  infohotspotListData: any;

  floorplanData: any;

  accessToken: any;
  loading = true;
  enableEditShowcase = false;
  selectedMedia: any;

  isModalShown = false;

  showVirtualTours = true;

  cameraPosition: any;

  constructor(
    public spaceService: SpaceService,
    public router: Router,
    private authService: AuthService,
    public memberService: MemberService
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    this.spaceService.spaceDataSubscription.subscribe(response => {
      if (Object.keys(response).length === 0 && response.constructor === Object) {
        this.router.navigate(['/member']);
      }
      if (response) {
        this.spaceData = response;
        this.getMediaDetails();
        // this.getHotspotList();
        // this.getInfoHotspotList();
      }
    });
  }

  uploadImagesEmit(response) {
    window.location.reload();
  }

  uploadVideoEmit(response) {
    window.location.reload();
  }

  getMediaDetails() {
    let selectedMedia;
    this.memberService.getMemberSpaceMediaDetails({
      Authorization: this.accessToken,
      id: this.spaceData.uuid
    }).subscribe((response: any) => {
      this.mediaData = response && response.media ? response.media : [];
      this.highLightReelData = response && response.highlightReel ? response.highlightReel : [];
      this.floorplanData = response && response.floorplan ? response.floorplan : undefined;
      selectedMedia = _.find(this.mediaData, {set_initial_view: 1});
      if (selectedMedia) {
        this.selectedMedia = selectedMedia;
      } else {
        // Check if highlight reel data exists
        if (this.highLightReelData.length > 0) {
            selectedMedia = _.find(this.mediaData, {uuid: this.highLightReelData[0].media_id });
            if (selectedMedia) {
              this.selectedMedia = selectedMedia;
            } else {
              this.selectedMedia = this.mediaData[0];
            }
        } else {
          this.selectedMedia = this.mediaData[0];
        }
      }
      this.loading = false;
      this.spaceService.setSpaceMediaData(this.mediaData);
      this.getHotspotList();
      this.getInfoHotspotList();
    }, err => {
      this.router.navigate(['/member']);
    });
  }

  editShowcase() {
    this.isModalShown = true;
  }

  closeEditVirtualToursEmit(event) {
    this.loading = true;
    this.showVirtualTours = true;
    setTimeout(() => {
      this.isModalShown = false;
    }, 1000);
    this.getMediaDetails();
  }

  seletedMediaEmit(response) {
    if (response.changeHotspot) {
      this.cameraPosition = response.cameraPosition;
      this.selectedMedia = response.selectedMedia;
    } else {
      this.selectedMedia = response;
    }
  }

  changeSpaceConfigEmit(config) {
    this.spaceData.config = config;
  }

  toggleVirtualTours() {
    this.showVirtualTours = false;
  }

  getHotspotList() {
    this.memberService.getHotspotList({
      Authorization: this.accessToken,
      id: this.spaceData.uuid
    }).subscribe((response: any) => {
      this.hotspotListData = response && response.data ? response.data : [];
    }, err => {
      this.hotspotListData = [];
    });
  }

  getInfoHotspotList() {
    this.memberService.getInfoHotspotList({
      Authorization: this.accessToken,
      id: this.spaceData.uuid
    }).subscribe((response: any) => {
      this.infohotspotListData = response && response.data ? response.data : [];
    }, err => {
      this.infohotspotListData = [];
    });
  }
}
